import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box, List } from '@mui/material';
import { useAppDispatch } from 'app/hooks';
import { ReactComponent as AdminIcon } from 'assets/icons/Icon-24-Admin.svg';
import { ReactComponent as AppSuiteIcon } from 'assets/icons/Icon-24-Application Suite.svg';
import { ReactComponent as MonitoringIcon } from 'assets/icons/Icon-24-Monitoring.svg';
import { ReactComponent as ReportsIcon } from 'assets/icons/Icon-24-Reports.svg';
import { ReactComponent as UsersIcon } from 'assets/icons/Icon-24-Users.svg';
import { ReactComponent as PalmDarkLogoIcon } from 'assets/icons/Palm-dark-Logo.svg';
import { ReactComponent as PalmLogoIcon } from 'assets/icons/Palm-Logo.svg';
import { Routes } from 'common/constants/routes';
import { ColorModeContext } from 'common/contexts/ColorModeContext';
import { useFeatures } from 'flagged';

import { menuToggle,selected } from './adminMenuSlice';
import { NavbarButton } from './NavbarButton';
import { ThemeSwitch } from './ThemeSwitch';

export function Navbar() {
    const location = useLocation();
    const { currentMode } = React.useContext(ColorModeContext);
    const adminChildren = ['global-roles'];
    const dispatch = useAppDispatch();
    const { themeSwitch, monitoring, reports, admin } = useFeatures();

    if (adminChildren.includes(location.pathname.split('/')[1]))
    {
        dispatch(selected());
        dispatch(menuToggle());
    }

    const buttonSx = {
        pl: 2,
        '&.MuiListItemButton-root': {
            backgroundColor: 'primary.main',
            borderRadius: 1,
            borderLeft: '4px solid transparent',
            transition: 'none',
            '&.active': {
                backgroundColor: 'primary.dark',
                '&:hover': {
                    backgroundColor: 'primary.dark',
                },
            },
            '&:hover': {
                backgroundColor: 'primary.light',
            },
        },
    };

    return (
        <Box
            sx={{
                top: 0,
                left: 0,
                width: '100%',
                minWidth: '220px',
                height: '100vh',
                backgroundColor: 'primary.main',
                display: 'inline-block',
                color: 'primary.contrastText',
                alignItems: 'center',
                position: 'sticky',
            }}
        >
            <Box
                sx={{
                    left: '10%',
                    width: '80%',
                    height: '100%',
                    position: 'relative',
                    alignItems: 'left',
                }}
            >
                <Box
                    sx={{ backgroundColor: 'primary.main', width: '100%', pl: 2, pt: 1 }}
                >
                    {currentMode === 'light' ? (
                        <PalmLogoIcon />
                    ) : (
                        <PalmDarkLogoIcon />
                    )}
                </Box>
                <List>
                    <NavbarButton
                        to={Routes.ApplicationSuites}
                        text="Application Suites"
                        icon={<AppSuiteIcon />}
                        buttonSx={buttonSx}
                    />
                    <NavbarButton
                        to={Routes.Users}
                        text="Users"
                        icon={<UsersIcon />}
                        buttonSx={buttonSx}
                    />
                    {reports &&
                    <NavbarButton
                        to={Routes.Reports}
                        text="Reports"
                        icon={<ReportsIcon />}
                        buttonSx={buttonSx}
                    />
                    }
                    {monitoring &&
                    <NavbarButton
                        to={Routes.Monitoring}
                        text="Monitoring"
                        icon={<MonitoringIcon />}
                        buttonSx={buttonSx}
                    />
                    }
                    {admin &&
                    <NavbarButton
                        to={Routes.Admin}
                        text="Admin"
                        icon={<AdminIcon />}
                        buttonSx={buttonSx}
                    />
                    }
                </List>
                {themeSwitch && <ThemeSwitch />}
            </Box>
        </Box>
    );
}
